import View, { AppHeaderProps as _AppHeaderProps} from "./app-header-view";
import {useAppLayoutContext} from "../app-layout-context";
import {useCallback, useEffect, useMemo, useState} from "react";

export interface AppHeaderProps extends Omit<_AppHeaderProps, "headerRef"|"variant"|"bodyVariant"|"isSticky"> {}
function AppHeader(props: AppHeaderProps) {
  const { setHeaderHeight } = useAppLayoutContext();
  // State handling for header state, i.e. "stuck" when content is scrolled under the ehader
  const [isSticky, setIsSticky] = useState(false);
  // State handling for bootstrap light/dark theme control with data-attributes
  const [headerVariant, setHeaderVariant] =
      useState<_AppHeaderProps["variant"]>("light");
  // State handling for bootstrap light/dark theme control with data-attributes
  const [bodyVariant, setBodyVariant] =
      useState<_AppHeaderProps["bodyVariant"]>("light");
  // Collect and store header height (e.g. for fixed header table scrolling to come in the future)
  const resizeObserver = useMemo(
      () =>
          new ResizeObserver((entries) => {
            if (entries[0] && setHeaderHeight) {
              setHeaderHeight(entries[0].contentRect.height);
            }
          }),
      [setHeaderHeight]
  );
  // Detects the header stuck state
  const intersectionObserver = useMemo(
      () => new IntersectionObserver(
        (entries) => {
          if (entries[0] && setIsSticky) {
            setIsSticky(entries[0].intersectionRatio < 1);
          }
        },// Only target the vertical
        {rootMargin:"0px 1000% 0px 1000%", threshold: [1]}
      ),
      [setIsSticky]
  )
  const [header, setHeader] = useState<HTMLElement|undefined|null>(undefined)
  const headerRef = useCallback((node: HTMLElement) => {
    setHeader(node);
  }, []);
  useEffect(() => {
    if (header) {
      resizeObserver.observe(header);
      intersectionObserver.observe(header);
      const cstyle = getComputedStyle(header);
      const variant = cstyle.getPropertyValue('--duke-header-bs-theme');
      const bodyVariant = cstyle.getPropertyValue('--duke-bs-theme');
      setHeaderVariant(variant);
      setBodyVariant(bodyVariant);
    }
    return () => {
      resizeObserver.disconnect();
      intersectionObserver.disconnect();
    };
  }, [header, intersectionObserver, resizeObserver]);
  return <View
      {...props}
      headerRef={headerRef}
      variant={headerVariant}
      bodyVariant={bodyVariant}
      isSticky={isSticky}
  />;
}
export default AppHeader;
